import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: 'app-rater-assesment-instructions',
  templateUrl: './rater-assessment-instructions.component.html',
  styleUrls: ['./rater-assessment-instructions.component.scss']
})
export class RaterAssessmentInstructionsComponent implements OnInit {

    id: number;
    raterName: string = '';

    constructor(private activatedRoute: ActivatedRoute) {
        this.activatedRoute.params.subscribe(params => {
            console.log(params['id']);
            this.id = params['id'];
        });
    }

  ngOnInit() {
  }

}
